import { Component, Inject, OnInit } from '@angular/core';
import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { CsrfTokenService } from './shared/services/csrf.service';
import { SessionMonitorService } from 'app/core/session/session-monitor.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    isIframe = false;

    constructor(private _platform: Platform, private csrfTokenService: CsrfTokenService, private _sessionMonitor: SessionMonitorService,
        @Inject(DOCUMENT) private document: any) {
        // Add is-mobile class to the body if the platform is mobile
        if (this._platform.ANDROID || this._platform.IOS) {
            this.document.body.classList.add('is-mobile');
        }


    }

    ngOnInit(): void {
        this.isIframe = window !== window.parent && !window.opener;
        this.csrfTokenService.fetchCsrfToken();
        this._sessionMonitor.startMonitoring();
    }


}
